module.exports = __webpack_public_path__ + "static/img/331.31aa99fb.jpeg";